import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
    fieldLabel: {
        fontSize: '16px',
        fontWeight: 600,
    }
}));

export default useStyles;